import React, { Component } from 'react'
import { Container, Row, Col } from 'reactstrap';
import { LabelErro } from './Layout/LabelErro'
import ReactLoading from "react-loading";
import api from '../services/api'
import { Button, Form } from 'react-bootstrap';
import { URL } from '../constants/index'

class CadastrarSenha extends Component {

    constructor(props) {
        super(props)

        this.state = {
            token: "",
            erroCadastrarSenha: "",
            senha: "",
            repetirSenha: "",
            tokenInvalido: true,
            loading: true
        }

        this.definirToken.bind(this)
        this.validarFormulario.bind(this)

    }

    definirToken() {
        let param = new URLSearchParams(this.props.location.search)
        var token = param.get("token")
        this.setState({ token: token })

        return token
    }

    startLoading() {
        this.setState({ loading: true })
    }

    stopLoading() {
        this.setState({ loading: false })
    }

    componentDidMount() {
        var token = this.definirToken();

        api.get("api/login/confirmartokensenha", {
            params: {
                token: token
            }
        })
            .then(res => {
                this.tratarTokenValido()
                this.stopLoading()
            })
            .catch(err => {
                this.tratarTokenInvalido()
                this.stopLoading()
            })

    }

    tratarTokenValido = e => {
        this.setState({ tokenInvalido: false })
    }

    tratarTokenInvalido = e => {
        this.setState({ tokenInvalido: true })
    }

    tratarErroCadastrarSenha = erro => {
        this.setState({ erroCadastrarSenha: erro })
    }

    handleSenha = e => {
        this.setState({ senha: e.target.value })
    }

    handleRepetirSenha = e => {
        this.setState({ repetirSenha: e.target.value })
    }
    handleCadastrarSenha = e => {
        e.preventDefault()
        if (!this.validarFormulario()) {
            return false
        }
        this.startLoading()

        api.post("/api/login/alterarsenha",
            {
                token: this.state.token,
                senha: btoa(this.state.senha)
            },
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
            .then(res => {
                this.stopLoading()
                this.onRetornarLogin();
            })
            .catch(err => {
                this.stopLoading()
                if (err.response && err.response.data) {
                    this.tratarErroCadastrarSenha(err.response.data.message)
                } else {
                    this.tratarErroCadastrarSenha("Erro ao se comunicar com API")
                }
            });

    }

    validarFormulario() {

        if (!this.state.senha || !this.state.repetirSenha) {
            this.tratarErroCadastrarSenha("Ambas as senhas precisam ser informadas")
            return false;
        }

        if (this.state.senha !== this.state.repetirSenha) {
            this.tratarErroCadastrarSenha("As senhas não coincidem")
            return false;
        }
        return true;
    }

    onRetornarLogin = e => {
        this.props.history.push(URL.URLLogin)
    }

    render() {

        if (this.state.loading) {
            return (
                <Container>
                    <Row className="justify-content-center">
                        <ReactLoading type="bubbles" color="#343a40" height={100} width={100} />
                    </Row>
                </Container>
            )
        }

        if (this.state.tokenInvalido) {
            return (
                <Container style={{ paddingTop: "100px" }}>
                    <Row className="justify-content-center">
                        <Col xs="6" style={{ padding: "20px" }} className="border" >
                            <Form>
                                <h3>Cadastrar senha</h3>
                                <hr />
                                <LabelErro caption="Token inválido"></LabelErro>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            )
        }

        return (
            <Container style={{ paddingTop: "100px" }}>
                <Row className="justify-content-center">
                    <Col xs="6" style={{ padding: "20px" }} className="border" >
                        <Form onSubmit={this.handleCadastrarSenha}>
                            <h3>Cadastrar senha</h3>
                            <hr />
                            {this.state.erroCadastrarSenha ? <LabelErro caption={this.state.erroCadastrarSenha}></LabelErro> : null}
                            <Form.Group controlId="senha">
                                <Form.Label>Senha</Form.Label>
                                <Form.Control type="password" placeholder="Senha" onChange={this.handleSenha} value={this.state.senha} />
                            </Form.Group>

                            <Form.Group controlId="repetir-senha">
                                <Form.Label>Repetir senha</Form.Label>                                
                                <Form.Control type="password" placeholder="Repetir senha" onChange={this.handleRepetirSenha} value={this.state.repetirSenha} />
                            </Form.Group>

                            {!this.state.loading ?
                                <Button variant="dark" type="submit" block>Definir senha</Button>                                
                                :
                                <Row className="justify-content-center">
                                    <ReactLoading type="bubbles" color="#343a40" height={100} width={100} />
                                </Row>
                            }
                        </Form>
                        <br />
                        <Button variant="dark" onClick={this.onRetornarLogin} block>Retornar para login</Button>                        
                    </Col>
                </Row>
            </Container>
        )
    }
}


export default CadastrarSenha;